import { useAuth } from '../contexts/AuthContext';

export const useWhiteLabelHiding = () => {
    const { user, currentOrganization } = useAuth();

    const shouldHidePaymentElements = () => {
        if (!currentOrganization || !user) {
            return false;
        }

        const shouldHide = currentOrganization.isWhiteLabelManaged === true && user.role !== 'whitelabel';

        return shouldHide;
    };

    return {
        shouldHidePaymentElements: shouldHidePaymentElements(),
        isWhiteLabelManaged: currentOrganization?.isWhiteLabelManaged === true,
        userRole: user?.role,
        isWhiteLabelUser: user?.role === 'whitelabel'
    };
};

export default useWhiteLabelHiding;


